<template lang="pug">
  div(:class="b()")
    .space-bottom RECONOCIDOS POR LOS PRINCIPALES MEDIOS
    .logos
      figure.logo(v-for="logo in logos" :key="logo.src")
        img(:src="logo.src")
</template>

<script>
  export default {
    name: 'trust-medios',

    data() {
      return {
        logos: [
          { src: this.$cloudfrontURL('/logos/gestion.png') },
          { src: this.$cloudfrontURL('/logos/entrepreneur.png') },
          { src: this.$cloudfrontURL('/logos/canal-n.png') },
          { src: this.$cloudfrontURL('/logos/gana-mas.png') },
        ],
      };
    },
  };
</script>